import React from 'react';
import { InjectedBreakpointsProps, withBreakpoints } from 'react-match-breakpoints';
import _ from 'lodash';

import { Typography, TypographyProps, Variant } from 'app/components/common/typography/typography';
import { BreakpointsUtils } from 'app/utils/breakpoints-utils';

export interface VariantMappingRules {
    [breakpoint: number]: { [variant in Variant]?: Variant };
}

interface OwnProps {
    rules: VariantMappingRules;
}

type Props = OwnProps & TypographyProps & InjectedBreakpointsProps;

const findVariant = (rules: VariantMappingRules, variant: Variant, width: number): Variant | undefined =>
    Object.entries(rules)
        .map(([breakpoint, mappings]) => ({ breakpoint: _.parseInt(breakpoint), mappings }))
        .sort(({ breakpoint: breakpoint1 }, { breakpoint: breakpoint2 }) => breakpoint1 - breakpoint2)
        .filter(({ breakpoint }) => breakpoint >= width)
        .map(({ mappings }) => mappings[variant])
        .find(Boolean);

const ResponsiveTypographyComponent = (props: Props) => {
    const { variant, breakpoints, rules, ...rest } = props;

    return (
        <Typography
            {...rest}
            variant={findVariant(rules, variant, BreakpointsUtils.findWidth(breakpoints)) || variant}
        />
    );
};

export const ResponsiveTypography = withBreakpoints(ResponsiveTypographyComponent);
